<style>
@import '../../custom/css/admin-navigation.css';
.menu-collapse {
  margin-left: 25px;
  margin-top: 20px;
}
.conteudo-area-restrita {
  margin-top: -45px;
}
</style>

<template>
  <div class="cliente">
    <div
      :class="!menuCollapse ? 'row ml-1 mr-3' : 'row m-0'"
      v-if="dadosUsuario !== null"
    >
      <div v-if="!menuCollapse" class="col-lg-3 col-md-3 p-0 bg-gray-1 mt-5">
        <div class="menu-area-restrita col-12">
          <Topic :text="'Informações'" :icon="'fas fa-user-circle'" />
          <BasicItem
            :text="'Meus Dados'"
            :icon="'fas fa-list-alt'"
            :routeName="'balconista-meus-dados'"
          />
          <BasicItem
            :text="'Realizar orçamento'"
            :icon="'fas fa-share-square'"
            :routeName="'balconista-realizar-orcamento'"
          />
          <!-- <BasicItem
            :text="'Meus saldos'"
            :icon="'fas fa-coins'"
            :routeName="'balconista-meus-saldos'"
          /> -->
          <BasicItem
            :text="'Sair'"
            :icon="'fas fa-power-off'"
            :routeName="'sair'"
          />

          <!-- Fim dos Meus Dados -->
          <Topic
            class="mt-4"
            :text="'Orçamentos'"
            :icon="'fas fa-clipboard-list'"
          />

          <Item
            :icon="'fas fa-arrow-circle-up'"
            :count="cotacoesContagem"
            :pushToRouteName="'balconista-orcamento-realizado'"
            :itemText="'Realizados'"
            :iconStyle="'transform: rotate(45deg)'"
          />

          <!-- MENUS PARA PERMISSÃO BALCONISTA -->
          <div class="mt-5" v-if="permissionClerk.length > 0">
            <Topic
              v-if="verifyPermission('inicio')"
              text="Início"
              icon="fas fa-home"
              pushToRouteName="balconista-app-home"
            />
            <Topic
              v-if="verifyPermission('verApp')"
              class="mt-4"
              text="Ver meu App"
              icon="fas fa-mobile-alt"
              pushToRouteName="balconista-ver-app"
            />
            <Topic
              v-if="verifyPermission('estatistica')"
              class="mt-4"
              text="Estatísticas"
              icon="fas fa-chart-line"
              pushToRouteName="balconista-app-estatisticas"
            />

            <!-- Pedidos -->
            <Topic
              v-if="verifyPermission('pedidos')"
              class="mt-4"
              text="Pedidos App"
              icon="fas fa-list-alt"
              pushToRouteName="balconista-pedidos-app"
            />
            <!-- <Topic
              v-if="
              verifyPermission('orcamentoWhatsapp') &&
                (
                  dadosUsuario.id == 4485 ||
                  dadosUsuario.id == 3848 ||
                  dadosUsuario.id == 4618
                )"
              class="mt-4"
              text="Orçamentos Whatsapp"
              icon="fab fa-whatsapp"
              pushToRouteName="balconista-orcamento-whatsapp"
            /> -->
            <Topic
              v-if="verifyPermission('carrinhoAbandonado')"
              class="mt-4"
              text="Carrinho Abandonado App"
              icon="fas fa-cart-plus"
              pushToRouteName="balconista-carrinho-abondonado"
            />
            <Topic
              v-if="verifyPermission('balconista')"
              class="mt-4"
              text="Vendedor App"
              icon="fas fa-user-tie"
              pushToRouteName="app-clerk"
            />
            <Topic
              v-if="verifyPermission('tipoCliente')"
              class="mt-4"
              text="Tipos de clientes"
              pushToRouteName="balconista-app-tipo-clientes"
              icon="fas fa-users-cog"
            />
            <Topic
              v-if="verifyPermission('clientesInfo')"
              class="mt-4"
              text="Clientes"
              pushToRouteName="balconista-clientes"
              icon="fas fa-users"
            />
            <!-- Produtos -->
            <Topic
              v-if="
                verifyPermission('selecionarProduto') ||
                verifyPermission('produtoSelecionado') ||
                verifyPermission('produtosComprados') ||
                verifyPermission('produtosBuscados') ||
                verifyPermission('impulsionarProdutos') ||
                verifyPermission('sugerirProduto')
              "
              class="mt-4"
              text="Produtos"
              icon="fas fa-th-list"
            />
            <Item
              v-if="verifyPermission('selecionarProduto')"
              icon="fas fa-tasks"
              pushToRouteName="balconista-produtos-selecao"
              itemText="Selecionar produtos"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('produtoSelecionado')"
              icon="fas fa-check-double"
              pushToRouteName="balconista-produtos-selecionados"
              itemText="Produtos selecionados"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('criarProduto')"
              icon="fas fa-box"
              pushToRouteName="balconista-produtos-criar"
              itemText="Criar produtos"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('sugerirProduto')"
              icon="fas fa-lightbulb"
              pushToRouteName="balconista-produtos-suggest"
              itemText="Sugerir produtos"
              hideCountBadge
            />
            <!-- <Item
                v-if="verifyPermission('cadastrarProduto')"
                icon="fas fa-box-open"
                pushToRouteName="balconista-produtos-insert"
                itemText="Cadastrar produtos"
                hideCountBadge
              /> -->
            <Item
              v-if="verifyPermission('servicos')"
              icon="fas fa-tools"
              pushToRouteName="balconista-service-insert"
              itemText="Serviços"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('aguardandoProdutos')"
              icon="fas fa-hourglass-half"
              pushToRouteName="balconista-wainting-product"
              itemText="Aguardando produtos"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('editarCategoria')"
              icon="fas fa-edit"
              pushToRouteName="balconista-edit-category"
              itemText="Editar categoria"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('gradeProduto')"
              icon="fas fa-th-large"
              pushToRouteName="balconista-variation-product"
              itemText="Grade de Produto"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('produtosComprados')"
              icon="fas fa-cart-plus"
              pushToRouteName="balconista-best-sellers"
              itemText="Produtos mais comprados"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('produtosBuscados')"
              icon="fas fa-search"
              pushToRouteName="balconista-product-search"
              itemText="Produtos buscados"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('impulsionarProdutos')"
              icon="fas fa-rocket"
              pushToRouteName="balconista-product-boost"
              itemText="Impulsionar produtos"
              hideCountBadge
            />

            <!-- Meios de pagamento -->
            <Topic
              v-if="verifyPermission('meioPagamento')"
              class="mt-4"
              text="Meios de pagamento"
              icon="fas fa-credit-card"
              pushToRouteName="balconista-app-meios-pagamentos"
            />

            <Topic
              v-if="verifyPermission('meioPagamento')"
              class="mt-4"
              text="Cupom de desconto"
              icon="fas fa-ticket-alt"
              pushToRouteName="balconista-app-cupom-desconto"
            />
            <Topic
              v-if="verifyPermission('meioPagamento')"
              class="mt-4"
              text="Cupom de cashback"
              icon="fas fa-coins"
              pushToRouteName="balconista-app-cupom-cashback"
            />
            <Topic
              v-if="methodWalletShopkeeper && verifyPermission('meioPagamento')"
              class="mt-4"
              text="Carteira Cliente"
              icon="fas fa-wallet"
              pushToRouteName="balconista-app-carteira"
            />

            <!-- Customizações -->
            <Topic
              v-if="
                verifyPermission('customizacaoEmpresa') ||
                verifyPermission('customizacaoCor') ||
                verifyPermission('customizacaoBanner') ||
                verifyPermission('customizacaoHome') ||
                verifyPermission('customizacaoSocial') ||
                verifyPermission('funcionamento') ||
                verifyPermission('panfletos')
              "
              class="mt-4"
              text="Customizações"
              icon="fas fa-cog"
            />
            <Item
              v-if="verifyPermission('customizacaoEmpresa')"
              icon="fas fa-align-left"
              pushToRouteName="balconista-customizacoes-sobre-empresa"
              itemText="Sobre a empresa"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('funcionamento')"
              icon="fas fa-clock"
              pushToRouteName="balconista-customizacoes-horario-funcionamento"
              itemText="Horário Funcionamento"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('customizacaoCor')"
              icon="fas fa-palette"
              pushToRouteName="balconista-customizacoes-mudar-cor"
              itemText="Mudar cor"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('customizacaoBanner')"
              icon="fas fa-image"
              pushToRouteName="balconista-customizacoes-banners"
              itemText="Banners"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('panfletos')"
              icon="fas fa-book-open"
              pushToRouteName="balconista-customizacoes-flyers"
              itemText="Panfletos"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('customizacaoHome')"
              icon="fas fa-align-justify"
              pushToRouteName="balconista-customizacoes-criar-categoria"
              itemText="Oferta(s) home"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('customizacaoSocial')"
              icon="fas fa-hashtag"
              pushToRouteName="balconista-customizacoes-redes-sociais"
              itemText="Contato e redes sociais"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('destaques')"
              icon="fas fa-hashtag"
              pushToRouteName="balconista-customizacoes-destaques"
              itemText="Destaques"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('meusLinks')"
              icon="fas fa-share-alt"
              pushToRouteName="balconista-customizacoes-linktree"
              itemText="Meus Links"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('promocoesDigitais')"
              icon="fas fa-ad"
              pushToRouteName="balconista-app-promocoes-digitais"
              itemText="Promoções digitais"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('pixelFacebook')"
              icon="fab fa-facebook"
              pushToRouteName="balconista-pixel-facebook"
              itemText="Pixel Facebook"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('ferramentasAnalise')"
              icon="fab fa-google"
              pushToRouteName="balconista-ferramentas-analise"
              itemText="Ferramentas de análise"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('termosCondicoes')"
              icon="fas fa-file-alt"
              pushToRouteName="balconista-termos-condicoes"
              itemText="Termos e condições"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('privacidade')"
              icon="fas fa-lock"
              pushToRouteName="balconista-privacidade"
              itemText="Privacidade"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('politicaDevolucao')"
              icon="fas fa-shipping-fast"
              pushToRouteName="balconista-politica-devolucao"
              itemText="Política de devolução"
              hideCountBadge
            />
            <Topic
              v-if="verifyPermission('frete')"
              pushToRouteName="balconista-frete-app"
              class="mt-4"
              text="Frete e entrega"
              icon="fas fa-truck"
            />
            <Topic
              v-if="verifyPermission('sorteioBalconista')"
              pushToRouteName="balconista-campanha-sorteio"
              class="mt-4"
              text="Sorteio"
              icon="fas fa-dice"
            />
            <Topic
              v-if="
                verifyPermission(
                  'notificacao' || 'notificacaoApp' || 'notificacaoWhatsapp'
                )
              "
              class="mt-4 mb-4"
              text="Notificações"
              icon="fas fa-bell"
            />
            <Item
              v-if="verifyPermission('notificacao')"
              icon="fas fa-paper-plane"
              pushToRouteName="balconista-app-notificacoes"
              itemText="Enviar notificações"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('notificacaoApp')"
              icon="fas fa-solid fa-bell"
              pushToRouteName="lojista-app-notificacoes-cms"
              itemText="Enviar notificações App"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('notificacaoWhatsapp')"
              icon="fab fa-whatsapp"
              pushToRouteName="lojista-app-notificacoes-whatsapp"
              itemText="Notificações do WhatsApp"
              hideCountBadge
            />
            <!-- <Topic
              v-if="solicitationApp.agent_ia && verifyPermission('agenteIa')"
              class="mt-4 mb-4"
              text="Agente de IA"
              icon="fas fa-robot"
              pushToRouteName="lojista-app-agente-ia"
            /> -->
            <Topic
              v-if="verifyPermission('solicitacaoProfissional')"
              class="mt-4 mb-4"
              text="Solicitações de profissionais"
              icon="fas fa-tasks"
              pushToRouteName="balconista-app-profissionais-solicitacoes"
            />
            <Topic
              v-if="
                verifyPermission('relatorioFacebookAds') ||
                verifyPermission('relatorioGoogleAnalytics') ||
                verifyPermission('relatorioQtdClicksWhatsApp') ||
                verifyPermission('relatorioQtdClicksContatos')
              "
              class="mt-4"
              text="Relatórios"
              icon="fas fa-file"
            />
            <Item
              v-if="verifyPermission('relatorioFacebookAds')"
              hideCountBadge
              itemText="Facebook Ads"
              icon="fas fa-hashtag"
              pushToRouteName="bolconista-report-facebook-ads"
            />
            <Item
              v-if="verifyPermission('relatorioGoogleAnalytics')"
              hideCountBadge
              itemText="Google Analytics"
              icon="fas fa-globe"
              pushToRouteName="balconista-report-google-analytics"
            />
            <Item
              v-if="verifyPermission('relatorioQtdClicksWhatsApp')"
              hideCountBadge
              itemText="Qtd. clicks WhatsApp"
              icon="fab fa-whatsapp"
              pushToRouteName="balconista-report-whatsapp-clicks"
            />
            <Item
              v-if="verifyPermission('relatorioQtdClicksContatos')"
              hideCountBadge
              itemText="Qtd. clicks contatos"
              icon="fas fa-share-alt"
              pushToRouteName="balconista-report-linktree-clicks"
            />
            <Topic
              v-if="
                verifyPermission('integrationMarketplaces') ||
                verifyPermission('integrationErp') ||
                verifyPermission('integrationTiny') ||
                verifyPermission('integrationGoogleShopping') ||
                verifyPermission('agenteIa') ||
                verifyPermission('antifraude')
              "
              class="mt-4"
              text="Integrações"
              icon="fab fa-connectdevelop"
            />
            <Item
              v-if="verifyPermission('integrationMarketplaces')"
              hideCountBadge
              itemText="Marketplaces"
              icon="fas fa-store"
              pushToRouteName="balconista-app-marketplaces"
            />
            <Item
              v-if="verifyPermission('integrationErp')"
              hideCountBadge
              itemText="ERPs"
              icon="fas fa-laptop-house"
              pushToRouteName="balconista-app-erp"
            />
            <Item
              v-if="verifyPermission('integrationTiny')"
              hideCountBadge
              itemText="Tiny"
              icon="fas fa-sync"
              pushToRouteName="balconista-app-tiny"
            />
            <Item
              v-if="verifyPermission('antifraude')"
              icon="far fa-credit-card"
              pushToRouteName="lojista-app-anti-fraud"
              itemText="Antifraude"
              hideCountBadge
            />
            <Item
              v-if="verifyPermission('integrationGoogleShopping')"
              hideCountBadge
              itemText="Google Shopping"
              icon="fas fa-tags"
              pushToRouteName="balconista-google-shopping"
            />
          </div>
        </div>
      </div>
      <div
        :class="
          !menuCollapse ? 'col-lg-9 col-md-9 col-sm-12 col-12 p-0 mt-3' : ''
        "
      >
        <div class="menu-collapse">
          <b-button pill variant="light" @click="collapseMenu()">
            <i v-if="!menuCollapse" class="fas fa-angle-left fs-24"></i>
            <i v-else class="fas fa-angle-right fs-24"></i>
          </b-button>
        </div>
        <div class="conteudo-area-restrita">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Item from '../../components/Menu/Item.vue';
import Topic from '../../components/Menu/Topic.vue';
import BasicItem from '../../components/Menu/BasicItem.vue';

export default {
  name: 'balconista',
  components: {
    Item,
    Topic,
    BasicItem,
  },
  data: () => ({
    cotacoesContagem: 0,
    menuCollapse: false,
    permissionClerk: [],
    methodWalletShopkeeper: false,
    isConstruct: false,
    solicitationApp: null,
  }),
  computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState({
      // Mapeamento de states
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
    }),
  },
  created() {
    this.qtdOrcamento();
    this.permissionClerkGet();
    // this.getVerifyIfHasApp();
  },
  methods: {
    collapseMenu() {
      console.log('oiii');
      this.menuCollapse = !this.menuCollapse;
      localStorage.setItem('menuCollapse', this.menuCollapse);
    },
    qtdOrcamento() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('balconista/contOrcamento', this.dadosUsuario.id)
        .then((response) => {
          this.cotacoesContagem = response.data.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    permissionClerkGet() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('balconista/getPermissionClerk', this.dadosUsuario.id)
        .then((response) => {
          this.permissionClerk = response.data.data;
          localStorage.setItem(
            'permissionClerk',
            JSON.stringify(response.data.data)
          );
        })
        .catch(() => {})
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    verifyPermission(value) {
      const result = this.permissionClerk.find(
        (element) => element.name == value
      );
      if (result != undefined && result.status == 1) return true;
      return false;
    },
    getMethoPayment() {
      this.$store.dispatch('startLoader');
      this.getPaymentMethods(this.dadosUsuario.id)
        .then((response) => {
          response.data.data.forEach((element) => {
            if (element.type == 4 && element.enabled == 1)
              this.methodWalletShopkeeper = true;
          });
        })
        .catch(() => {})
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    getVerifyIfHasApp() {
      this.verifyIfHasApp(this.dadosUsuario.construp_user_id)
        .then((response) => {
          const {
            hasApp,
            demoApp,
            activeConstrup,
            solicitation,
            solicitationApp,
          } = response.data || {};

          // this.hasApp = hasApp || false;
          // this.demoApp = demoApp || false;
          // this.activeConstrup = activeConstrup || false;
          // this.solicitation = solicitation || '';
          this.solicitationApp = solicitationApp || null;
        })
        .catch(() => {
          this.hasApp = false;
        })
        .finally(() => {
          this.loadingIfHasApp = false;
        });
    },
  },
};
</script>
